import React from "react";
import { Route, Routes } from "react-router-dom";

import Apps from "./Apps";
import Funds from "./Funds";
import Holdings from "./Holdings";
import Orders from "./Orders";
import Positions from "./Positions";
import Summary from "./Summary";
import WatchList from "./WatchList";
import Tickets from "./Tickets";
import OptionChain from "./OptionChain";
import StrategyBuilder from "./StrategyBuilder";
import StatementExport from "./StatementExport";
import { GeneralContextProvider } from "./GeneralContext";

const Dashboard = () => {
  return (
    <div className="dashboard-container" style={{ display: "flex", width: "100%", height: "calc(100vh - 50px)", overflow: "hidden", backgroundColor: "#ffffff" }}>
      <GeneralContextProvider>
        <WatchList />
      </GeneralContextProvider>
      <div className="content" style={{ flex: 1, height: "100%", overflowY: "auto", padding: "0", boxSizing: "border-box" }}>
        <Routes>
          <Route exact path="/" element={<Summary />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/holdings" element={<Holdings />} />
          <Route path="/positions" element={<Positions />} />
          <Route path="/option-chain" element={<OptionChain />} />
          <Route path="/strategy-builder" element={<StrategyBuilder />} />
          <Route path="/funds" element={<Funds />} />
          <Route path="/statement" element={<StatementExport />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/apps" element={<Apps />} />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
